module.exports = __webpack_public_path__ + "img/flow-02.7ac71232.svg";